import React from 'react';
import styled from 'styled-components';
import { SearchInput } from '../../../../../generic/ui/SearchInput';
import { DatePicker } from '../../../../../generic/ui/DatePicker';
import KbdChipButton from '../../../../../generic/ui/KbdChipButton/KbdChipButton';
import LikutWarehouseFilterButton from './LikutWarehouseFilterButton';
import MapPinIcon from '../../../../../generic/icons/IconLib/MapPinIcon';
import InfoIcon from '../../../../../generic/icons/IconLib/InfoIcon';
import { IWarhouseListItem } from '../../../../../modules/API/Defaults/models/warhouseList';

interface Props {
    input: string;
    setInput: (value: string) => void;
    placeholder?: string;
    setSelectedDateStart: (value: string) => void;
    sortedByRamp: boolean;
    sortByRamp: () => void;
    tranzitID: number;
    handleSelectTransit: (id: number) => void;
    warehouseList: IWarhouseListItem[] | null;
    isNeedToSortByKav: boolean;
    isDev: boolean;
    handleOpenDefaults: () => void;
}

const LikutSelectBar: React.FC<Props> = ({
    input,
    setInput,
    placeholder,
    setSelectedDateStart,
    sortedByRamp,
    sortByRamp,
    tranzitID,
    handleSelectTransit,
    warehouseList,
    isNeedToSortByKav,
    isDev,
    handleOpenDefaults,
}) => {
    return (
        <SelectBarShell>
            <SearchInput
                value={input}
                onChange={(e) => setInput(e.target.value)}
                placeholder={placeholder ?? 'חיפוש'}
            />
             <DatePicker
                disabled
                setDate={setSelectedDateStart}
            />
            {isNeedToSortByKav && warehouseList && (
                <LikutWarehouseFilterButton
                    warehouseList={warehouseList}
                    tranzitID={tranzitID}
                    handleSelectTransit={handleSelectTransit}
                />
            )}
            <KbdChipButton
                variant={sortedByRamp ? 'accent' : 'default'}
                onClick={sortByRamp}
                aria-label='סדר לפי רמפה'
                title='סדר לפי רמפה'
            >
                <MapPinIcon size={16} color='currentColor' />
            </KbdChipButton>
            {isDev && (
                <KbdChipButton
                    onClick={handleOpenDefaults}
                    aria-label='ברירות מחדל'
                    title='ברירות מחדל'
                >
                    <InfoIcon size={16} color='currentColor' />
                </KbdChipButton>
            )}
           
        </SelectBarShell>
    );
};

export default LikutSelectBar;

const SelectBarShell = styled.div`
    position: relative;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 0.5rem;
`;
